import { useMemo } from 'react';
import { BemHelperType, getBemHelper } from 'src/utils/bemHelper';

export function useBemHelper(blocks: string[]): BemHelperType[];

export function useBemHelper(block: string): BemHelperType;

export function useBemHelper(blocks: string | string[]): BemHelperType | BemHelperType[] {
  /* block names shouldn't change */
  // eslint-disable-next-line
  return useMemo(() => (Array.isArray(blocks) ? blocks.map((block) => getBemHelper(block)) : getBemHelper(blocks)), []);
}
